import useSWR from 'swr'
import {fetchDistricts} from '@frontrow/console/src/helpers/api-districts'
import {type FetchDataParamsT} from '@frontrow/console/src/components/common/data-table'
import {fromOpenApiDistricts, type DistrictT} from '@frontrow/console/src/models/district'
import {firstResponseApiError} from '@frontrow/console/src/entities/models/api-error'

const DISTRICTS_SWR_KEY = 'districts'

export function useDistricts(fetchDataParams?: FetchDataParamsT | null): {
  data: Array<DistrictT> | undefined
  error: Error | undefined
  isLoading: boolean
  mutate: () => Promise<Array<DistrictT> | undefined>
} {
  const {data, error, isLoading, mutate} = useSWR(
    [DISTRICTS_SWR_KEY, fetchDataParams],
    async ([_, params]) => {
      const response = await fetchDistricts(params)
      const districts = fromOpenApiDistricts(response)
      return districts
    }
  )

  return {data, error, isLoading, mutate}
}

export function useDistrict(districtId: number) {
  return useSWR([DISTRICTS_SWR_KEY, districtId], async () => {
    try {
      const response = await fetchDistricts()
      const districts = fromOpenApiDistricts(response)
      return districts.find(d => d.id === districtId)
    } catch (err: unknown) {
      const apiError = firstResponseApiError(err)
      throw new Error(apiError.message)
    }
  })
}
